
<div class="hpanel">
  <div class="panel-body b-r-6">
    <div class="row">
      <div class="col-sm-12">
        <div class="card">
          <div class="card-header custom-card-header">
            <!-- Header Title -->
            <h5 class="header-title">Billing Details</h5>

            <!-- Controls on the Right -->
            <div class="header-controls">
                <!-- Refresh Button -->
                <span class="refresh-btn" title="Refresh" (click)="Refresh()">
                    <ng-icon name="tablerRefresh"></ng-icon>
                </span>

                <!-- Dropdown -->
                <select class="custom-dropdown form-control" placeholder="All Transactions" type="text" [(ngModel)]="selectedYear" (ngModelChange)="onYearChange()">
                    <option value="null" disabled [selected]="true">All Transactions</option>
                    <option *ngFor="let year of years" [value]="year">{{ year }}</option>
                </select>

                <!-- Excel File Button -->
                <!-- <div class="excel-btn" (click)="generateExcelFile()">
                    <ng-icon name="tablerFileSpreadsheet"></ng-icon>
                </div> -->

                <button (click)="generateExcelFile()" class="btn  btn-primary svg-excel">
                  <ng-icon name="tablerFileSpreadsheet"></ng-icon>
                  Download
                </button>


            </div>
        </div>


          <!-- Card Body with Table -->
          <div class="card-body custom-datatable">
            <!-- Empty state -->
            <div *ngIf="(listToShow$ | async)?.length === 0" class="datatable-empty-state">
              <app-nodata-found
                [title]="['No billing records found']"
                [screen]="'EMPTY'"
                [buttonShow]="false">
              </app-nodata-found>
            </div>

            <!-- Datatable with data -->
            <div *ngIf="(listToShow$ | async)?.length > 0">
              <ngx-datatable   #sortTable (sort)="onSort($event)" class="bootstrap" [rows]="listToShow$ | async" [columnMode]="'force'" [headerHeight]="40"
               [footerHeight]="50" [rowHeight]="'auto'" [limit]="10" [selectAllRowsOnPage]="false"
               (select)='onSelect($event)' [externalPaging]="true" [count]="params.totalCount" [scrollbarH]="true"
               [offset]="params.page" (page)="nextPage($event)">

               <!-- Define your columns -->
               <ngx-datatable-column cellClass="colValuesync" name="Date" prop="createdOn">
                 <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                   <label>{{ row.createdOn | timezoneDate:'MM/dd/yyyy' }}</label>
                 </ng-template>
               </ngx-datatable-column>

               <ngx-datatable-column cellClass="colValuesync" [width]="250" name="Description" prop="createdOn">
                 <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                   <label>{{ row.createdOn | timezoneDate:'MM/dd/yyyy' }} -- {{row.membershipType}} --
                     {{row.billingType}}</label>
                 </ng-template>
               </ngx-datatable-column>

               <ngx-datatable-column cellClass="colValuesync" name="Transaction Status" prop="status">
                 <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                   <td class="td-center" [ngStyle]="{ color: getPaymentStatusColor(row.paymentStatus) }">
                     {{ getPaymentStatusText(row.paymentStatus) }}
                   </td>
                 </ng-template>
               </ngx-datatable-column>

               <ngx-datatable-column cellClass="colValuesync" name="Remarks" prop="status">
                 <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                  <label matTooltip="{{ row.formattedRemark }}">
                    {{ row.formattedRemark?.length > 30 ? (row.formattedRemark | slice:0:50) + '...' : row.formattedRemark }}
                </label>
                 </ng-template>
               </ngx-datatable-column>
               <ngx-datatable-column name="Invoice ID" prop="invoiceId" [cellTemplate]="invoiceIdTemplate">
               </ngx-datatable-column>



               <ngx-datatable-column cellClass="colValuesync" name="Amount" prop="status">
                 <ng-template let-row="row" let-value="value" ngx-datatable-cell-template>
                   <label *ngIf="row.membershipType == 'ScaleX'">${{ row.subcriptionAmount }}{{ row.invoiceId ? '' : ' + tax' }}</label>
                   <label *ngIf="row.membershipType != 'ScaleX'">${{ row.subcriptionAmount / 100 }}</label>
                 </ng-template>
               </ngx-datatable-column>
             </ngx-datatable>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<ng-template #invoiceIdTemplate let-row="row">
  <td class="td-center">
    <button *ngIf="!row.invoiceId && row.paymentStatus != 'INACTIVE' && row.paymentStatus != 'FAILED' && row.paymentStatus != 'CANCELLED' && row.membershipType == 'ScaleX'" class="btn btn-primary" (click)="scalexPayment(row)">Pay</button>
    <p *ngIf="!row.invoiceId && (row.paymentStatus == 'INACTIVE' || row.paymentStatus == 'FAILED' || row.paymentStatus == 'CANCELLED') && row.membershipType == 'ScaleX'">-</p>
    <a style="color:blue" *ngIf="row.invoiceId" [href]="row.invoiceUrl" target="_blank">{{ row.invoiceId }}</a>
    <p *ngIf="!row.invoiceId && row.membershipType != 'ScaleX'">-</p>
  </td>
</ng-template>
